import Tooltip from '../Tooltip/Tooltip';
import { ReactComponent as InformationIcon } from '../../../assets/icons/aml/information.svg';
import React, { useCallback, useRef } from "react";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calender.svg";
import "../../../css/DesignSystem/Inputs/NewDateField.css";

const NewDateField = ({
  id,
  name,
  min,
  max,
  inputProps = {},
  label,
  tooltip,
  value,
  onChange,
  required = false,
  disabled = false,
  readOnly = false,
  error = false,
  helperText = "",
}) => {
  const inputRef = useRef(null);
  const inputId =
    id ||
    `date-${String(label || "field")
      .replace(/\s+/g, "-")
      .toLowerCase()}`;
  const inputValue =
    value instanceof Date && !Number.isNaN(value.getTime())
      ? [
          value.getFullYear(),
          String(value.getMonth() + 1).padStart(2, "0"),
          String(value.getDate()).padStart(2, "0"),
        ].join("-")
      : value || "";

  const openCalendar = useCallback(() => {
    if (disabled || readOnly) return;
    inputRef.current?.focus();
    try {
      inputRef.current?.showPicker?.();
    } catch {
      // Browsers without showPicker still focus the native date input.
    }
  }, [disabled, readOnly]);

  return (
    <div className="AnnouncementInputField fit-column gap-xs">
      {label && (
        <label
          htmlFor={inputId}
          className="AnnouncementInputField__Label FP_Content text-black"
        >
          {label}{" "}
          {required && (
            <span className="FP_Content_Semibold text-error">*</span>
          )}
        {tooltip && <Tooltip content={tooltip} position="top"><InformationIcon className="ds-portal-input-tooltip-icon" aria-label={typeof label === 'string' ? label + ' help' : 'Field help'} /></Tooltip>}
        </label>
      )}
      <div className="fp-date-input-wrapper">
        <input
          {...inputProps}
          name={name || inputId}
          min={min}
          max={max}
          required={required}
          readOnly={readOnly}
          aria-invalid={!!error}
          aria-describedby={error && helperText ? `${inputId}-error` : undefined}
          ref={inputRef}
          id={inputId}
          type="date"
          value={inputValue}
          onChange={readOnly ? undefined : onChange}
          disabled={disabled}
          aria-readonly={readOnly}
          className={`FP_Content fp-form-input fp-date-input ${error ? "fp-form-input--error" : ""}`}
        />
        <button
          type="button"
          className="fp-date-calendar-button"
          onClick={(event) => {
            event.stopPropagation();
            openCalendar();
          }}
          disabled={disabled || readOnly}
          aria-label={`Open ${label || "date"} calendar`}
        >
          <CalendarIcon aria-hidden="true" />
        </button>
      </div>
      {error && helperText && (
        <p id={`${inputId}-error`} className="AnnouncementInputField__Error FP_Content text-error">{helperText}</p>
      )}
    </div>
  );
};

export default NewDateField;
